import React from 'react';
import SalesInfo from '../../components/Retaillib/sales/SalesInfo';

const Sales = () => {
  return (
    <div className='absolute w-full h-full'>
      <SalesInfo />
    </div>
  );
}

export default Sales;
